import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import PreviewElement from './PreviewElement';
import PreviewIconLink from './PreviewIconLink';
import PreviewLink from './PreviewLink';
import Draggable from 'react-draggable';
class FilterBarPreview extends Component {
    render() {
        return (
            <div
                className="FilterBarPreview"
                style={{ backgroundColor: this.props.filterBarPreview.general.backgroundColor }}
            >
                <div className="row">
                    <PreviewElement
                        className="col-xs-12 col-sm-8"
                        fontData={this.props.filterBarPreview.primaryText}
                        text="64 ROOM RESULTS"
                    />
                    <PreviewIconLink
                        fontData={this.props.filterBarPreview.primaryText}
                        className="col-xs-12 col-sm-2 filter-bar-divider"
                        text="Sort by:  Relevance"
                        icon="spark-icon-arrow-chevron-down spark-icon--md"
                    />
                    <PreviewLink
                        fontData={this.props.filterBarPreview.primaryText}
                        colorData={this.props.filterBarPreview.defaultLink}
                        className="col-xs-12 col-sm-2"
                        text="SHOW FILTERS"
                    />
                </div>
            </div>
        );
    }
}

FilterBarPreview.propTypes = {
    primaryText: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.filterBar, ...state.theme.filterBar };
};

export default connect(mapStateToProps)(FilterBarPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/FilterBarPreview.js